import { ModalFullscreen, IconClose16, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatModal.css';

export interface IChatModalProps {
  isOpen: boolean;
  src: string | null;
  onOpen?(): void;
  onClose(): void;
}

export function ChatModal({ isOpen, src, onClose, onOpen }: IChatModalProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  React.useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen, onOpen]);

  if (!src) {
    return null;
  }

  return (
    <ModalFullscreen onClose={onClose} open={isOpen} theme="white">
      <div className={styles['iframe-container']}>
        <span className={styles['close']} onClick={onClose}>
          <IconClose16 />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        <iframe data-name="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
      </div>
    </ModalFullscreen>
  );
}
